import mastercard from "@/assets/cards/MasterCard50.gif";
import visa from "@/assets/cards/Visa50.gif";
import maestro from "@/assets/cards/maestro50.gif";
import mastercadIDCheck from "@/assets/cards/mastercard-identity-check.png";
import securityMetricsPass from "@/assets/cards/securityMetricsPass.png";
import visaSecure from "@/assets/cards/visa-secure.png";
import { useTranslation } from "react-i18next";

export const AcceptedCards = () => {
  const { t } = useTranslation();

  return (
    <div className="acceptedCards">
      <a
        href="https://www.wspay.info"
        title={t("acceptedCardTitles.monriWSPay")}
        target="_blank"
        rel="noreferrer"
      >
        <img
          alt="Monri WSpay - Web Secure Payment Gateway"
          src="https://www.wspay.info/payment-info/wsPayWebSecureLogo-118x50-transparent.png"
        />
      </a>
      <img
        alt="SecurityMetrics card safe certification logo"
        src={
          securityMetricsPass ||
          "https://www.securitymetrics.com/portal/app/ngsm/assets/img/GreyContent_Credit_Card_Safe_White_Rec.png"
        }
      />
      <a
        href="https://www.visaeurope.com"
        target="_blank"
        rel="noopener noreferrer"
        title={t("acceptedCardTitles.visa")}
      >
        <img src={visa} alt="visa" />
      </a>
      <a
        href="https://www.wspay.info/verified-by-visa.html"
        target="_blank"
        rel="noopener noreferrer"
        title={t("acceptedCardTitles.visaSecure")}
      >
        <img src={visaSecure} alt="visaSecure" />
      </a>
      <a
        href="https://www.mastercard.com"
        target="_blank"
        rel="noopener noreferrer"
        title={t("acceptedCardTitles.mastercard")}
      >
        <img src={mastercard} alt="mastercard" />
      </a>
      <a
        href="https://www.wspay.info/mastercard-securecode.html"
        target="_blank"
        rel="noopener noreferrer"
        title={t("acceptedCardTitles.mastercardSecure")}
      >
        <img src={mastercadIDCheck} alt="mastercardIDCheck" />
      </a>
      <a
        href="https://www.mastercard.hr/hr-hr/consumers/find-card-products/debit-cards/maestro-debit.html"
        target="_blank"
        rel="noopener noreferrer"
        title={t("acceptedCardTitles.maestro")}
      >
        <img src={maestro} alt="maestro" />
      </a>
    </div>
  );
};

// Unused cards, left here to for future potential use

//<a
//  href="https://www.americanexpress.com/hr/merchant/welcome-to-american-express.html"
//  target="_blank"
//  rel="noopener noreferrer"
//>
//  <img src={amex} alt="americanExpress" />
//</a>

//<a href="http://www.diners.com.hr" target="_blank" rel="noopener noreferrer">
//  <img src={diners} alt="diners" />
//</a>

//<a href="https://www.discover.com/" target="_blank" rel="noopener noreferrer">
//  <img src={discover} alt="discover" />
//</a>

//<a href="http://www.diners.com.hr/" rel="noopener noreferrer">
//  <img src={dinaCard} alt="dinaCard" />
//</a>
